import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { TP } from '../../constants/consts';
import Button from '../Button';
import LastUpdate from '../LastUpdate';
import { useTranslation } from '../../src/i18n';
import { scrollToInvalidField } from '../../utils/common';

const useStyles = makeStyles(() => ({
  footer: {
    display: 'flex',
  },
  saveBtn: {
    marginRight: '21px',
  },
}));

export function SaveButtonBlock({ updatedDate, onSaveClick, buttonText, buttonVariant, isLoading, isDisabled }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.footer}>
      <Button
        variant={buttonVariant}
        className={classes.saveBtn}
        type="submit"
        onClick={() => {
          onSaveClick();
          scrollToInvalidField();
        }}
        isLoading={isLoading}
        disabled={isDisabled}
      >
        {buttonText ? t(buttonText) : t(`${TP}.FN_SAVE_NEXT`)}
      </Button>
      {updatedDate && <LastUpdate date={updatedDate} />}
    </div>
  );
}

SaveButtonBlock.propTypes = {
  updatedDate: PropTypes.string,
  onSaveClick: PropTypes.func,
  buttonText: PropTypes.string,
  buttonVariant: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

SaveButtonBlock.defaultProps = {
  updatedDate: '',
  onSaveClick: () => {},
  buttonVariant: 'outlined',
  isDisabled: false,
  isLoading: false,
};

export default memo(SaveButtonBlock);
